import { axios } from "../lib";
import * as endpoints from "./apiEndpoints";

class TaxCodeService {
  static loadTaxCodes() {
    const url = `${endpoints.BASE_URL}${endpoints.TAX_CODES}`;
    return axios.get(url).then((response) => response.data);
  }
}

export default TaxCodeService;
